const styles = (theme) => ({
    graphic: {
        width: '50%',
        margin: '0 auto',
        display: 'block',
    },
    paper: {
        padding: theme.spacing(4),
        width: '60%',
        margin: '0 auto',
    },
    [theme.breakpoints.down('sm')]: {
        paper: {
            minWidth: '100%',
            margin: '0',
        },
        graphic: {
            marginTop: '5em',
        },
    },
});

export default styles;
